import { GlobalStyles } from '@mui/material';

// Always mounted, independent of the visitor's own "Reduce motion" toggle
// or whether the accessibility launcher is enabled at all — the OS-level
// prefers-reduced-motion signal must be honored even if the visitor never
// opens the panel. The theme-level equivalent (collapsing MUI's own
// transitions.create output) is handled separately in
// AccessibilityPreferencesProvider, which folds this same OS signal into
// the effective theme via useReducedMotion().
export function GlobalMotionStyles() {
  return (
    <GlobalStyles
      styles={{
        '@media (prefers-reduced-motion: reduce)': {
          '*, *::before, *::after': {
            animationDuration: '0.01ms !important',
            animationIterationCount: '1 !important',
            transitionDuration: '0.01ms !important',
            scrollBehavior: 'auto !important',
          },
        },
      }}
    />
  );
}
